import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { mainText } from 'aegisv2/styles/colors';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import { connect } from 'react-redux';
import T from 'aegisv2/Text';
import ArrowLeft from 'crehana-icons/ArrowLeft';
import Times from 'crehana-icons/Times';
import ContentWrapper from 'Catalog/ui/ContentWrapper';
import { secondaryMain } from 'crehana-ui/styles/colors';
import STRINGS from 'Catalog/strings';

import {
  COURSES_PAGE_SIZE,
  formatCourseV2,
  checkIfisInShoppingCart,
} from 'Catalog/utils';
import GroupTitle from 'Catalog/ui/GroupTitle';
import {
  getCategorySelected,
  getLevelsSelected,
  getSoftwaresSelected,
  getSelectedLanguages,
} from 'Jsx/Catalog/components/FiltersV2/redux/selectors';

import {
  toggleFilterCategory,
  toggleFilterLevel,
  toggleFilterSoftware,
  toggleFilterLanguage,
  clearAllFilters,
  disableSoftwaresAndLevels,
} from 'Jsx/Catalog/components/FiltersV2/redux/actions';

import CourseRecommended from 'Jsx/Catalog/components/CourseRecommended';
import OrderByV2 from 'Jsx/Catalog/components/OrderByV2';

import getCourses from '../../graphql/getCourses.gcg.graphql';
import CourseList from '../../containers/CourseList';

import {
  getCurrentPage,
  getTotalPages,
  setCurrentPage,
  setTotalPages,
} from '../../Pagination/ducks';

import Pagination from '../../Pagination';

import {
  PaginationWrapper,
  ContentTopWrapper,
  ScrollTopWrapper,
  ScrollTopIconWrapper,
  EmptySubTitle,
  ResultsTitle,
  FilterTagWrapper,
  FilterTag,
  OrderByWrapper,
} from './styles';

const ClearFilterButton = styled.button`
  display: none;
  @media (min-width: 768px) {
    display: inline-block;
    margin-bottom: 10px;
    outline: none;
  }
`;

const ExtraButtonMobile = styled.div`
  display: block;
  padding: 4px 0px;
  @media (min-width: 768px) {
    ${''}
    padding: 0 0 16px 0;
    margin: 0 auto;
  }

  @media (min-width: 1140px) {
    padding: 0;
    margin-bottom: 0;
    display: none;
  }
`;

class ResultsV2 extends Component {
  state = {
    loading: false,
    courses: 0,
  };

  componentDidUpdate(prevProps) {
    const { softwares, levels, queryVariables, loading } = this.props;

    const hasVariablesChanged = Object.keys(queryVariables).some(
      key =>
        key !== 'newSoftwares' &&
        queryVariables[key] !== prevProps.queryVariables[key] &&
        key !== 'level',
    );

    const wasANewRequest = !loading && loading !== prevProps.loading;
    const hasChanged = hasVariablesChanged || wasANewRequest;

    if (hasChanged && !loading) {
      this.props.disableSoftwaresAndLevels({ softwares, levels });
    }
  }

  handleOnClickLevel = ({ subItemId }) => () =>
    this.props.toggleFilterLevel({ subItemId });

  handleOnClickLanguages = ({ subItemId }) => () =>
    this.props.toggleFilterLanguage({ subItemId });

  handleOnClickSoftware = ({ subItemId }) => () =>
    this.props.toggleFilterSoftware({ subItemId });

  handleOnClickSubCategory = ({ itemId, subItemId }) => () =>
    this.props.toggleFilterCategory({ itemId, subItemId });

  render() {
    const {
      loading,
      totalPages,
      courses,
      courseIdsOwned,
      theme,
      removeCourseFromCart,
      resultTitle,
      scrollTop,
      search,
      addCourseToCart,
      user,
      levelsSelected,
      softwaresSelected,
      selectedLanguages,
      isOrganization,
      loadingCartButton,
      userLanguage,
      cleanFiltersMsg,
      totalCount,
    } = this.props;

    if (!loading && (!courses || !courses.length)) {
      const emptyTitle = `No hemos encontrado resultados para "${search ||
        resultTitle}"`;

      return (
        <ContentWrapper>
          <GroupTitle>{emptyTitle}</GroupTitle>
          <EmptySubTitle>{STRINGS.results.emptySubTitle}</EmptySubTitle>
          <ExtraButtonMobile>
            <div style={{ marginBottom: 16 }}>
              <T
                size={16}
                bold
                color={secondaryMain}
                onClick={this.props.clearAllFilters}
              >
                {cleanFiltersMsg}
              </T>
            </div>
          </ExtraButtonMobile>
          <CourseRecommended
            courseIdsOwned={courseIdsOwned}
            removeCourseFromCart={removeCourseFromCart}
            addCourseToCart={addCourseToCart}
          />
        </ContentWrapper>
      );
    }

    const title = search
      ? `Resultados de búsqueda para "${search}"`
      : resultTitle;

    const hasFilterTagsToShow =
      levelsSelected.length > 0 ||
      softwaresSelected.length > 0 ||
      selectedLanguages.length > 0;

    return (
      <ContentWrapper>
        <ContentTopWrapper
          a="flex-start"
          J="space-between"
          d="row"
          hasSubTitle={false}
        >
          <ResultsTitle d="column" hasFilterTagsToShow={hasFilterTagsToShow}>
            <h1 className="font-gil font-bold text-24 leading-32">{title}</h1>
            {/* {!loading && false ? <SubTitle>{`${courses.length} cursos`}</SubTitle> : null} */}
          </ResultsTitle>

          {!this.props.allCourses &&
            !this.props.search &&
            !this.props.showCustomRecommended && (
              <div style={{ marginTop: 16 }}>
                <ExtraButtonMobile>
                  {totalCount ? (
                    <T size={16}>Encontramos {totalCount} resultados</T>
                  ) : null}
                </ExtraButtonMobile>
                <ExtraButtonMobile>
                  <T
                    size={14}
                    bold
                    color={secondaryMain}
                    onClick={this.props.clearAllFilters}
                  >
                    {cleanFiltersMsg}
                  </T>
                </ExtraButtonMobile>
              </div>
            )}
          <OrderByWrapper style={{ marginTop: '0 !important' }}>
            <OrderByV2 scrollTop={scrollTop} withOrderByLabel />
          </OrderByWrapper>
        </ContentTopWrapper>
        <FilterTagWrapper
          style={{ marginBottom: hasFilterTagsToShow ? 24 : 0 }}
        >
          {levelsSelected.map(level => (
            <FilterTag
              onClick={this.handleOnClickLevel({ subItemId: level.id })}
              key={`levels-${level.id}`}
            >
              <Times color={mainText} size={8} />
              <T xs size={12}>
                {level.name}
              </T>
            </FilterTag>
          ))}
          {softwaresSelected.map(software => (
            <FilterTag
              key={`software-${software.id}`}
              onClick={this.handleOnClickSoftware({ subItemId: software.id })}
            >
              <Times color={mainText} size={8} />
              <T xs size={12}>
                {software.name}
              </T>
            </FilterTag>
          ))}
          {selectedLanguages.map(language => (
            <FilterTag
              key={`software-${language.id}`}
              onClick={this.handleOnClickLanguages({ subItemId: language.id })}
            >
              <Times color={mainText} size={8} />
              <T xs size={12}>
                {language.name}
              </T>
            </FilterTag>
          ))}
          {hasFilterTagsToShow && (
            <ClearFilterButton onClick={this.props.clearAllFilters}>
              <T xs bold color={secondaryMain}>
                Limpiar todo
              </T>
            </ClearFilterButton>
          )}
        </FilterTagWrapper>
        <CourseList
          userLanguage={userLanguage}
          skeletonItems={24}
          courseIdsOwned={courseIdsOwned}
          courses={courses}
          loading={loading}
          removeCourseFromCart={removeCourseFromCart}
          addCourseToCart={addCourseToCart}
          isUserLogged={!!user}
          user={user}
          isOrganization={isOrganization}
          loadingCartButton={loadingCartButton}
        />
        <PaginationWrapper>
          <ScrollTopWrapper a="center" mr="22px" onClick={scrollTop}>
            <ScrollTopIconWrapper>
              <ArrowLeft color={theme.colors.filter} size={7} />
            </ScrollTopIconWrapper>
            <T bold color={secondaryMain}>
              {STRINGS.backToTop}
            </T>
          </ScrollTopWrapper>
          <Pagination loading={loading} totalPages={totalPages} />
        </PaginationWrapper>
      </ContentWrapper>
    );
  }
}

ResultsV2.propTypes = {
  // enable eslint if it is necessary
  // eslint-disable-next-line react/no-unused-prop-types
  courseIdsOwned: PropTypes.arrayOf(PropTypes.number).isRequired,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      affiliateCommission: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      affiliateUrl: PropTypes.string,
      buyUrl: PropTypes.string,
      discount: PropTypes.number,
      duration: PropTypes.number,
      id: PropTypes.number,
      imagePlaceholder: PropTypes.string,
      inShoppingCart: PropTypes.bool,
      isEnrolled: PropTypes.bool,
      isEnrollment: PropTypes.bool,
      level: PropTypes.shape({
        name: PropTypes.string,
      }),
      originalId: PropTypes.number,
      prices: PropTypes.shape({
        currencySymbol: PropTypes.string,
        price: PropTypes.number,
        realPrice: PropTypes.number,
      }),
      promoImage: PropTypes.string,
      score: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  cleanFiltersMsg: PropTypes.string.isRequired,
  currentPage: PropTypes.number,
  loading: PropTypes.bool,
  orderBy: PropTypes.string,
  pages: PropTypes.number,
  removeCourseFromCart: PropTypes.func.isRequired,
  addCourseToCart: PropTypes.func.isRequired,
  resultTitle: PropTypes.string.isRequired,
  scrollTop: PropTypes.func.isRequired,
  search: PropTypes.string,
  setCurrentPage: PropTypes.func.isRequired,
  setTotalPages: PropTypes.func.isRequired,
  softwares: PropTypes.arrayOf(PropTypes.string),
  levels: PropTypes.arrayOf(PropTypes.string),

  levelsSelected: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  softwaresSelected: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  categorySelected: PropTypes.shape({}),
  subCategoriesSelected: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

  // redux actions
  clearAllFilters: PropTypes.func.isRequired,
  toggleFilterCategory: PropTypes.func.isRequired,
  toggleFilterLevel: PropTypes.func.isRequired,
  toggleFilterSoftware: PropTypes.func.isRequired,
  // styled-components theme
  theme: PropTypes.shape({}).isRequired,
  totalPages: PropTypes.number,
  user: PropTypes.shape({}),
  isOrganization: PropTypes.bool,
  loadingCartButton: PropTypes.bool.isRequired,
  userLanguage: PropTypes.string.isRequired,
};

ResultsV2.defaultProps = {
  courses: undefined,
  currentPage: 1,
  loading: false,
  orderBy: '',
  pages: 1,
  search: null,
  softwares: null,
  levels: null,
  totalPages: 1,
  user: null,
  categorySelected: null,
  isOrganization: false,
};

const getCursor = (currentPage, pageSize) => {
  // in SSR return the page 0 in base64 (arrayconnection:0)
  if (typeof window === 'undefined') return 'YXJyYXljb25uZWN0aW9uOjA=';
  return btoa(`arrayconnection:${(currentPage - 1) * pageSize - 1}`);
};

const mapStateToProps = state => {
  const { categorySelected, subCategoriesSelected } = getCategorySelected(
    state,
  );
  const levelsSelected = getLevelsSelected(state);
  const selectedLanguages = getSelectedLanguages(state);
  const softwaresSelected = getSoftwaresSelected(state);
  const orderBySelected = state.orderBy.itemSelected;

  return {
    // search: getSearch(state),
    orderBy: orderBySelected.value,
    userLanguage: state.userLanguage,
    categorySelected,
    subCategoriesSelected,
    selectedLanguages,
    levelsSelected,
    softwaresSelected,
    currentPage: getCurrentPage(state),
    pages: getTotalPages(state),
    coursesNoResults: [],
    resultTitle:
      (subCategoriesSelected.length > 0 &&
        `Cursos online de ${subCategoriesSelected[0].name}`) ||
      (categorySelected && `Cursos online de ${categorySelected.name}`) ||
      (softwaresSelected.length > 0 &&
        `Cursos online de ${softwaresSelected
          .map(software => software.name)
          .join(', ')}`) ||
      (levelsSelected.length > 0 &&
        `Cursos online de nivel ${levelsSelected
          .map(l => l.name)
          .join(', ')}`) ||
      (orderBySelected &&
        orderBySelected.slug === 'online' &&
        'Todos los cursos') ||
      (orderBySelected &&
        orderBySelected.slug === 'ofertas' &&
        `Cursos en ${orderBySelected.value}`) ||
      (orderBySelected && `Cursos ${orderBySelected.value}`),
  };
};

// a simple request id to not send duplicate requests if the component re-render from the parent
let criteoRequestId = '';

const mapResultsToProps = ({ getCourses, ownProps }) => {
  // eslint-disable-line no-shadow, max-len
  const props = {
    loading: getCourses.loading,
    queryVariables: getCourses.variables,
  };

  if (!getCourses.loading && getCourses.courses) {
    const { courses } = getCourses;

    props.totalPages = Math.ceil(courses.totalCount / COURSES_PAGE_SIZE);
    props.totalCount = courses.totalCount;

    props.queryId = Date.now();
    props.courses = courses.edges
      .map(e => e.node)
      .map(formatCourseV2)
      .map(checkIfisInShoppingCart(ownProps.courseIdsOwned));

    // the query returns what softwares/levels has the current category/subCategory
    props.softwares = getCourses.courses.softwares;
    props.levels = getCourses.courses.levels;

    try {
      // Use the variables of the query to identify the request
      // so we only run the criteo_q.push function once time for each new query
      const currentCriteoRequestId = JSON.stringify(getCourses.variables);

      if (!criteoRequestId || criteoRequestId !== currentCriteoRequestId) {
        criteoRequestId = currentCriteoRequestId;
        const coursesIdsArray = props.courses
          .map(course => course.originalId || course.id)
          .map(courseId => courseId.toString());

        if (window.criteo_q) {
          window.criteo_q.push({ event: 'viewList', item: coursesIdsArray });
        }
      }
    } catch (error) {
      console.error(
        'Error to stringify the variables query or to run the criteo function',
        error,
      );
    }
  }

  return props;
};

export default compose(
  connect(mapStateToProps, {
    setCurrentPage,
    setTotalPages,

    toggleFilterLevel,
    toggleFilterLanguage,
    toggleFilterSoftware,
    toggleFilterCategory,
    clearAllFilters,
    disableSoftwaresAndLevels,
  }),
  graphql(getCourses, {
    name: 'getCourses',
    options: ({
      orderBy,
      categorySelected,
      subCategoriesSelected,
      levelsSelected,
      selectedLanguages,
      softwaresSelected,
      currentPage,
      search,
    }) => ({
      variables: {
        pageSize: COURSES_PAGE_SIZE,
        newCategories: categorySelected ? categorySelected.slug : null,
        newSubCategories: categorySelected
          ? subCategoriesSelected.map(sc => sc.slug).join(',')
          : null,
        newSoftwares: softwaresSelected
          .map(software => software.slug)
          .join(','),
        language: selectedLanguages.map(el => el.slug).join(','),
        newOrderBy: orderBy,
        level: levelsSelected.map(level => level.slug).join(','),
        search,
        cursor: getCursor(currentPage, COURSES_PAGE_SIZE),
      },
    }),
    props: mapResultsToProps,
  }),
  withTheme,
)(ResultsV2);
